import styled from 'styled-components';

export const InfoText = styled.h2`
  font-size: 32px;
  line-height: 42px;
  font-weight: 900;
  color: #4e3f6e;
  margin-bottom: 12px;
  text-align: center;
`;
export const SummaryText = styled.p`
  font-size: 16px;
  margin-bottom: 12px;
`;

export const OfferText = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 8px;
  background: #e6fff9;
  color: #007e7d;
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
  margin-bottom: 40px;
  text-align: center;
  width: max-content;
  margin: 0 auto;
`;

export const AEDImg = styled.img`
  margin-top: 8px;
`;

export const Body = styled.div`
  width: 1200px;
  margin: 0px auto;
  margin-bottom: 48px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  .perfectCenter {
    display: flex;
  }

  .dirColumn {
    flex-direction: column;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 258px;
  background-color: #ffffff;
  width: 1200px;
  margin: 50px auto;
`;

export const OfferHeading = styled.p`
  color: #4e3f6e;
  font-size: 26px;
  font-weight: 900;
  line-height: 42px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 10%;
  margin-right: 10%;

}
`;

export const OfferSubHeading = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: #007e7d;
  background-color: #e6fff9;
  padding: 0.5em 1em;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 14px;
`;

export const InrSymbol = styled.span<{isAed: boolean}>`
  font-size: ${props => (props.isAed ? '8px' : '14px')};
  border: 1px solid;
  color: black;
  width: 22px;
  height: 22px;
  padding: 4px;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  vertical-align: bottom;
  justify-content: unset;
  text-align: revert;
  text-justify: revert-layer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  background: linear-gradient(197.72deg, #f8e24e 2.2%, #eec42f 102.46%);
`;

export const ContinueButton = styled.button`
  background: linear-gradient(93.66deg, #53b2fe 0%, #065af3 100%);
  display: 'flex';
  border-radius: 23px;
  border: none;
  justify-content: 'center';
  padding: 10px;
  color: white;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  margin: 0 auto;
`;
